'use strict';


import { getLoginRequiredResolveObj } from "../shared/utils/angularUtils";
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const scanIqCustomerManagementModule = angular
  .module('app.scanIqCustomerManagement', [])
  .config(scanIqCustomerManagementConfig);

scanIqCustomerManagementConfig.$inject = ['$routeProvider'];

function scanIqCustomerManagementConfig($routeProvider) {
  $routeProvider
    .when('/inbody-scaniq', {
      template: '<ngz-in-body-scan-iq></ngz-in-body-scan-iq>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/customers-dashboard/scan-iq', {
      template: '<ngz-customers-dashboard-scan-iq></ngz-customers-dashboard-scan-iq>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.SCAN_IQ,
        breadcrumbs: [
          { label: 'Customers', icon: NAVIGATION_ICON.PEOPLE_OUTLINE }
        ]
      }
    })
    .when('/customer-profile/scan-iq/:entityId/:customerId', {
      reloadOnSearch: false,
      template: '<ngz-scan-iq-customer-profile></ngz-scan-iq-customer-profile>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.SCAN_IQ,
        breadcrumbs: [
          { label: 'Customer Profile', icon: NAVIGATION_ICON.PEOPLE_OUTLINE }
        ]
      }
    });
}
